import { render, staticRenderFns } from "./FacetContentBlocks.vue?vue&type=template&id=0ce14a90&"
import script from "./FacetContentBlocks.vue?vue&type=script&lang=js&"
export * from "./FacetContentBlocks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports